import useEventListener from "@saleor/hooks/useEventListener";
import { makeStyles } from "@saleor/macaw-ui";
import React, { RefObject, useEffect, useRef } from "react";

interface StickyHorizontalScrollBarProps {
  container: RefObject<HTMLDivElement>;
  reRender?: boolean;
  bottom?: number;
}
interface propsType {
  bottom?: number;
}
const useStyles = makeStyles<propsType>(
  () => ({
    root: {
      zIndex: 1000,
      display: "none",
      position: "fixed",
      bottom: props => `${props.bottom || 0}px`,
      overflowX: "auto",
      "&::-webkit-scrollbar": {
        height: "14px",
        background: "#FFFFFF"
      },
      "&::-webkit-scrollbar-track": {
        borderRadius: 10
      },
      "&::-webkit-scrollbar-thumb": {
        background: "#CCCCCC",
        borderRadius: 10,
        border: "4px solid #FFFFFF",
        height: "6px"
      }
    }
  }),
  { name: "StickyHorizontalScrollBar" }
);
function checkPosition(
  container: RefObject<HTMLDivElement>,
  fixedBarTemplate: RefObject<HTMLDivElement>,
  bottomFixed?: number
) {
  const containerOffset = {
    top: container.current.offsetTop,
    bottom: container.current.offsetTop + container.current.offsetHeight
  };
  const windowOffset = {
    top: window.scrollY,
    bottom: window.scrollY + window.innerHeight - bottomFixed * 2
  };

  if (
    containerOffset.top > windowOffset.bottom ||
    windowOffset.bottom > containerOffset.bottom ||
    window.innerHeight -
      container.current?.getBoundingClientRect()?.bottom -
      bottomFixed >
      0
  ) {
    fixedBarTemplate.current.style.display = "none";
  } else {
    fixedBarTemplate.current.style.display = "block";
    fixedBarTemplate.current.scrollLeft = container.current.scrollLeft;
  }
}

const StickyHorizontalScrollBar: React.FC<StickyHorizontalScrollBarProps> = ({
  container,
  reRender = false,
  bottom = 0
}) => {
  const fixedBarTemplate = useRef<HTMLDivElement | null>(null);
  const scrollBar = useRef<HTMLDivElement | null>(null);
  const classes = useStyles({ bottom });
  useEffect(() => {
    if (scrollBar.current && container.current) {
      scrollBar.current.style.height = "1px";
      scrollBar.current.style.width = `${container.current.scrollWidth}px`;
      scrollBar.current.scrollLeft = container.current.scrollLeft;
      fixedBarTemplate.current.style.width = `${container.current.offsetWidth}px`;
      checkPosition(container, fixedBarTemplate, bottom);
    }
  }, [scrollBar, container, reRender]);

  useEventListener(
    "scroll",
    () => {
      container.current.scrollLeft = fixedBarTemplate.current.scrollLeft;
    },
    fixedBarTemplate
  );

  useEventListener("scroll", () => {
    checkPosition(container, fixedBarTemplate, bottom);
  });

  return (
    <div className={classes.root} ref={fixedBarTemplate}>
      <div ref={scrollBar}></div>
    </div>
  );
};

export default StickyHorizontalScrollBar;
